<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M4 20V4c0-1.1.89-2 2-2h12c1.1 0 2 .9 2 2v16h1c.55 0 1 .45 1 1s-.45 1-1 1H3c-.56 0-1-.45-1-1s.44-1 1-1h1Zm9-8h-2v2h2v-2Zm3 0v2h2v-2h-2Zm-5 4v2h2v-2h-2Zm7 0h-2v2h2v-2ZM6 12v2h2v-2H6Zm7-6V4h-2v2H9v2h2v2h2V8h2V6h-2ZM8 16H6v2h2v-2Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M6 3c0-1.11.89-2 2-2h8c1.1 0 2 .89 2 2v2c1.65 0 3 1.34 3 3v12h1c.55 0 1 .45 1 1s-.45 1-1 1H2c-.56 0-1-.45-1-1s.44-1 1-1h1V8c0-1.66 1.34-3 3-3V3Zm2 0v8h8V3H8Zm5 1v2h2v2h-2v2h-2V8H9V6h2V4h2ZM5 20h14V8c0-.55-.45-1-1-1v4c0 1.1-.9 2-2 2H8c-1.11 0-2-.9-2-2V7c-.56 0-1 .45-1 1v12Zm6.5-6h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.56 0-1-.45-1-1s.44-1 1-1Zm3.5 1c0-.55.44-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.56 0-1-.45-1-1Zm1 2h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.56 0-1-.45-1-1s.44-1 1-1Zm-5.5 1c0-.55.44-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.56 0-1-.45-1-1ZM7 17h1c.55 0 1 .45 1 1s-.45 1-1 1H7c-.56 0-1-.45-1-1s.44-1 1-1Zm-1-2c0-.55.44-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1H7c-.56 0-1-.45-1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
